import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "24x24/share",
    clipPath: "url(#clip_Share)"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 0.2928L12 -0.414307L11.2929 0.2928L7.29289 4.2928L8.70711 5.70701L11 3.41412V13.9999H13V3.41412L15.2929 5.70701L16.7071 4.2928L12.7071 0.2928ZM5 7.99991C3.89543 7.99991 3 8.89534 3 9.99991V20.9999C3 22.1045 3.89543 22.9999 5 22.9999H19C20.1046 22.9999 21 22.1045 21 20.9999V9.99991C21 8.89534 20.1046 7.99991 19 7.99991H17V9.99991H19V20.9999H5V9.99991H7V7.99991H5Z",
    fill: "currentColor"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Share24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var Share24 = createIcon(IconComponent);